/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, BigNumberish, Overrides } from 'ethers'
import type { Provider, TransactionRequest } from '@ethersproject/providers'
import type { PromiseOrValue } from '../../common'
import type { Pages, PagesInterface } from '../../art-gobblers/Pages'

const _abi = [
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_mintStart',
        type: 'uint256',
      },
      {
        internalType: 'contract Goo',
        name: '_goo',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_community',
        type: 'address',
      },
      {
        internalType: 'contract ArtGobblers',
        name: '_artGobblers',
        type: 'address',
      },
      {
        internalType: 'string',
        name: '_baseUri',
        type: 'string',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'currentPrice',
        type: 'uint256',
      },
    ],
    name: 'PriceExceededMax',
    type: 'error',
  },
  {
    inputs: [],
    name: 'ReserveImbalance',
    type: 'error',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'spender',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
    ],
    name: 'Approval',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'bool',
        name: 'approved',
        type: 'bool',
      },
    ],
    name: 'ApprovalForAll',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'lastMintedPageId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'numPages',
        type: 'uint256',
      },
    ],
    name: 'CommunityPagesMinted',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'user',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'pageId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'price',
        type: 'uint256',
      },
    ],
    name: 'PagePurchased',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
    ],
    name: 'Transfer',
    type: 'event',
  },
  {
    inputs: [],
    name: 'BASE_URI',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
    ],
    name: 'approve',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'artGobblers',
    outputs: [
      {
        internalType: 'contract ArtGobblers',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
    ],
    name: 'balanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'community',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'currentId',
    outputs: [
      {
        internalType: 'uint128',
        name: '',
        type: 'uint128',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'getApproved',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'int256',
        name: 'sold',
        type: 'int256',
      },
    ],
    name: 'getTargetSaleTime',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'int256',
        name: 'timeSinceStart',
        type: 'int256',
      },
      {
        internalType: 'uint256',
        name: 'sold',
        type: 'uint256',
      },
    ],
    name: 'getVRGDAPrice',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'goo',
    outputs: [
      {
        internalType: 'contract Goo',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
    ],
    name: 'isApprovedForAll',
    outputs: [
      {
        internalType: 'bool',
        name: 'isApproved',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'numPages',
        type: 'uint256',
      },
    ],
    name: 'mintCommunityPages',
    outputs: [
      {
        internalType: 'uint256',
        name: 'lastMintedPageId',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'maxPrice',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: 'useVirtualBalance',
        type: 'bool',
      },
    ],
    name: 'mintFromGoo',
    outputs: [
      {
        internalType: 'uint256',
        name: 'pageId',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'mintStart',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'name',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'numMintedForCommunity',
    outputs: [
      {
        internalType: 'uint128',
        name: '',
        type: 'uint128',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
    ],
    name: 'ownerOf',
    outputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'pagePrice',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes',
      },
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'operator',
        type: 'address',
      },
      {
        internalType: 'bool',
        name: 'approved',
        type: 'bool',
      },
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes4',
        name: 'interfaceId',
        type: 'bytes4',
      },
    ],
    name: 'supportsInterface',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [],
    name: 'symbol',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'targetPrice',
    outputs: [
      {
        internalType: 'int256',
        name: '',
        type: 'int256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'pageId',
        type: 'uint256',
      },
    ],
    name: 'tokenURI',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256',
      },
    ],
    name: 'transferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
]

const _bytecode =
  '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'

type PagesConstructorParams = [signer?: Signer] | ConstructorParameters<typeof ContractFactory>

const isSuperArgs = (
  xs: PagesConstructorParams,
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1

export class Pages__factory extends ContractFactory {
  constructor(...args: PagesConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args)
    } else {
      super(_abi, _bytecode, args[0])
    }
  }

  override deploy(
    _mintStart: PromiseOrValue<BigNumberish>,
    _goo: PromiseOrValue<string>,
    _community: PromiseOrValue<string>,
    _artGobblers: PromiseOrValue<string>,
    _baseUri: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> },
  ): Promise<Pages> {
    return super.deploy(
      _mintStart,
      _goo,
      _community,
      _artGobblers,
      _baseUri,
      overrides || {},
    ) as Promise<Pages>
  }
  override getDeployTransaction(
    _mintStart: PromiseOrValue<BigNumberish>,
    _goo: PromiseOrValue<string>,
    _community: PromiseOrValue<string>,
    _artGobblers: PromiseOrValue<string>,
    _baseUri: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> },
  ): TransactionRequest {
    return super.getDeployTransaction(
      _mintStart,
      _goo,
      _community,
      _artGobblers,
      _baseUri,
      overrides || {},
    )
  }
  override attach(address: string): Pages {
    return super.attach(address) as Pages
  }
  override connect(signer: Signer): Pages__factory {
    return super.connect(signer) as Pages__factory
  }

  static readonly bytecode = _bytecode
  static readonly abi = _abi
  static createInterface(): PagesInterface {
    return new utils.Interface(_abi) as PagesInterface
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Pages {
    return new Contract(address, _abi, signerOrProvider) as Pages
  }
}
